import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import * as S from '../../styles';

export function Footer() {
	const { onPreviousStep } = useCalculateReturnOfInvestments();

	function handleOnPreviousStep(): void {
		onPreviousStep();
	}

	return (
		<Row justify="center" gutter={[30, 0]}>
			<Col>
				<S.PreviousButton onClick={handleOnPreviousStep}>{I18n.get('Previous')}</S.PreviousButton>
			</Col>
		</Row>
	);
}
